<template>
  <div>
    <template v-if="pms">
      <account-title></account-title>
      <account-search></account-search>
      <account-table></account-table>
      <account-components></account-components>
    </template>

    <no-pms v-else></no-pms>
  </div>
</template>

<script>
import mixin from "./components/Mixins";
import components from "./components";
import NoPms from "@/components/NoPms.vue";

export default {
  data() {
    return {
      pms: false,
    };
  },
  components: { NoPms },
  mixins: [components, mixin],
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
    　　history.pushState(null, null, document.URL);
　　 });

    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms = pms["40000"].check;
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/PartI/OperationAccount/index.vue